import React from 'react'

const cardColorClasses: Record<string, { bg: string, text: string, icon: string }> = {
  botticelli: { bg: 'bg-botticelli', text: 'text-botticelli-dark', icon: 'text-botticelli-dark' },
  emerald: { bg: 'bg-emerald-light', text: 'text-emerald-dark', icon: 'text-emerald-dark' },
  'polo-blue': { bg: 'bg-polo-blue-light', text: 'text-polo-blue-dark', icon: 'text-polo-blue-dark' },
  'cerise-red': { bg: 'bg-cerise-red-light', text: 'text-cerise-red-dark', icon: 'text-cerise-red-dark' },
  anzac: { bg: 'bg-anzac-light', text: 'text-anzac-dark', icon: 'text-anzac-dark' },
  green: { bg: 'bg-emerald-light', text: 'text-emerald-dark', icon: 'text-emerald-dark' },
  blue: { bg: 'bg-botticelli', text: 'text-botticelli-dark', icon: 'text-botticelli-dark' },
  gray: { bg: 'bg-gray-100', text: 'text-gray-700', icon: 'text-gray-500' },
}

interface CardProps {
  heading?: React.ReactNode
  color?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Icon?: React.ComponentType<any>
  children?: React.ReactNode
  className?: string
  headless?: boolean
}

const Card: React.FC<CardProps> = ({ heading = '\u00a0', color, Icon = undefined, children, className = '', headless = false }) => {
  const colorClasses = color ? cardColorClasses[color] : undefined
  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-xs">
      {!headless && (
        <div
          className={`${colorClasses?.bg ?? ''} ${colorClasses?.text ?? ''} border-b border-gray-200 py-1 sm:py-2 px-4 sm:px-6 relative`}>
          {heading}
          {Icon && <Icon className={`hidden sm:inline ${colorClasses?.icon ?? ''} w-6 h-6 absolute`} style={{ top: '7px', right: '7px' }} />}
        </div>
      )}
      <div className={className}>
        {children}
      </div>
    </div>
  )
}

export default Card
